import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, API, TOKEN_KEY } from "../lib/api";

export default function Assessment() {
  const navigate = useNavigate();
  const [token, setToken] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (!t) {
      navigate("/", { replace: true });
      return;
    }
    api
      .get("/access/verify-token", { params: { token: t } })
      .then(({ data }) => {
        if (data.valid) {
          setToken(t);
          setChecking(false);
        } else {
          localStorage.removeItem(TOKEN_KEY);
          navigate("/", { replace: true });
        }
      })
      .catch(() => {
        localStorage.removeItem(TOKEN_KEY);
        navigate("/", { replace: true });
      });
  }, [navigate]);

  if (checking) {
    return (
      <div className="evc-frame-loading" data-testid="evc-frame-loading">
        <Loader2 size={28} className="evc-spin" />
        <span className="lbl">Validating access…</span>
      </div>
    );
  }

  return (
    <div className="evc-frame-wrap" data-testid="evc-assessment-frame">
      <iframe
        className="evc-frame"
        src={`${API}/assessment/${token}`}
        title="EVC ITFM Maturity Assessment"
        allow="clipboard-write"
      />
    </div>
  );
}
